import { useEffect } from 'react'
import { close, open } from '../index'

const useExpandCollapse = (display, trigger, container) => {
  useEffect(() => {
    if (display) {
      trigger.current.setAttribute('aria-expanded', true);
      container.current.style.visibility = 'visible';
      trigger.current.parentNode.classList.add('accordion__item--expanded');
      trigger.current.parentNode.classList.remove('accordion__item--collapsed');
      open({
        element: container.current,
        onComplete: () => {
          container.current.setAttribute('aria-hidden', false);
          container.current.style.height = 'auto';
        }
      });

    } else {
      trigger.current.setAttribute('aria-expanded', false);
      trigger.current.parentNode.classList.remove('accordion__item--expanded');
      trigger.current.parentNode.classList.add('accordion__item--collapsed');
      close({
        element: container.current,
        onComplete: () => {
          container.current.setAttribute('aria-hidden', true);
          container.current.style.visibility = 'hidden';
        }
      });
    }
  }, [display]);
};

export default useExpandCollapse;
